const AboutSHAY = () => {
  const traits = ['Worship', 'Surrender', 'Spiritual Hunger', 'Bold Faith', 'Holy Living'];

  return (
    <section
      id="about-shay"
      className="relative py-28 px-6 overflow-hidden"
      style={{ background: 'linear-gradient(180deg, #0c0c0c 0%, #080808 100%)' }}
    >
      {/* BG image, very subtle */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/6f0c4a5d7daf24e5864aa94c1bb92ee8.jpg')`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          opacity: 0.1,
        }}
      />
      {/* Vignette */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{ background: 'radial-gradient(ellipse at center, transparent 30%, rgba(0,0,0,0.7) 100%)' }}
      />
      {/* Top border */}
      <div
        className="absolute top-0 left-0 right-0 h-px pointer-events-none"
        style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.5), transparent)' }}
      />

      <div className="max-w-2xl mx-auto relative z-10">
        {/* Section label */}
        <div className="text-center mb-10">
          {/* Badge */}
          <div
            className="inline-flex items-center gap-2 mb-6 px-5 py-1.5 rounded-full text-xs font-bold tracking-widest uppercase"
            style={{ background: 'rgba(212,168,66,0.1)', border: '1px solid rgba(212,168,66,0.35)', color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
          >
            <span>✦</span> The Movement
          </div>

          {/* Title directly under badge */}
          <div className="relative">
            <div
              className="absolute inset-0 pointer-events-none"
              style={{ background: 'radial-gradient(ellipse at center, rgba(212,168,66,0.18) 0%, transparent 65%)' }}
            />
            <h2
              className="relative anim-text-glow"
              style={{
                fontFamily: "'Holy Midnight', cursive",
                fontSize: 'clamp(3.5rem, 14vw, 7rem)',
                color: '#D4A842',
                lineHeight: 1.1,
                letterSpacing: '0.02em',
              }}
            >
              Shay Generation
            </h2>
          </div>
        </div>

        {/* Description card */}
        <div
          className="rounded-2xl p-7 md:p-9 mb-6 relative overflow-hidden"
          style={{
            background: 'linear-gradient(145deg, rgba(212,168,66,0.07) 0%, rgba(255,255,255,0.02) 100%)',
            border: '1px solid rgba(212,168,66,0.2)',
          }}
        >
          <div
            className="absolute bottom-0 right-0 w-40 h-40 pointer-events-none"
            style={{ background: 'radial-gradient(circle at bottom right, rgba(212,168,66,0.08) 0%, transparent 70%)' }}
          />
          <p className="text-base md:text-lg text-gray-200 leading-loose mb-5" style={{ fontFamily: "'Glacial Indifference', sans-serif" }}>
            SHAY carries a burden for the next generation. It is a movement with a heart to see{' '}
            <strong className="text-white">youth saved, transformed, established in truth</strong>, and drawn into a real encounter with God.
          </p>
          <p className="text-sm md:text-base leading-loose" style={{ color: '#999', fontFamily: "'Glacial Indifference', sans-serif" }}>
            SHAY calls young people into:
          </p>
          <div className="flex flex-wrap gap-2 mt-3">
            {traits.map((t) => (
              <span
                key={t}
                className="px-3.5 py-1.5 rounded-full text-xs font-semibold"
                style={{
                  background: 'rgba(212,168,66,0.1)',
                  border: '1px solid rgba(212,168,66,0.28)',
                  color: '#ECD9A0',
                  fontFamily: "'Glacial Indifference', sans-serif",
                }}
              >
                {t}
              </span>
            ))}
          </div>
        </div>

        {/* Scripture */}
        <div
          className="rounded-2xl p-8 md:p-10 text-center relative overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, rgba(212,168,66,0.14) 0%, rgba(212,168,66,0.04) 100%)',
            border: '1.5px solid rgba(212,168,66,0.4)',
          }}
        >
          <div
            className="absolute inset-0 pointer-events-none"
            style={{ background: 'radial-gradient(ellipse at center, rgba(212,168,66,0.07) 0%, transparent 70%)' }}
          />
          {/* Decorative quote marks */}
          <div
            className="text-5xl font-black mb-4 relative z-10"
            style={{ color: 'rgba(212,168,66,0.3)', fontFamily: 'Playfair Display, serif', lineHeight: 1 }}
          >
            &ldquo;
          </div>
          <p
            className="text-xl md:text-2xl font-bold italic leading-relaxed mb-2 relative z-10"
            style={{
              fontFamily: 'Playfair Display, serif',
              color: '#FFFFFF',
              textShadow: '0 2px 20px rgba(0,0,0,0.8)',
            }}
          >
            Be still, and know that I am God.
          </p>
          <p
            className="text-sm font-bold tracking-widest uppercase mb-6 relative z-10"
            style={{ color: '#D4A842', fontFamily: "'Glacial Indifference', sans-serif" }}
          >
            — Psalm 46:10
          </p>
          <div
            className="h-px w-20 mx-auto mb-5 relative z-10"
            style={{ background: 'linear-gradient(90deg, transparent, rgba(212,168,66,0.6), transparent)' }}
          />
          <p
            className="text-base italic leading-relaxed relative z-10"
            style={{ color: '#C0A060', fontFamily: 'Playfair Display, serif' }}
          >
            In a noisy generation, God is still calling hearts<br />to stand still and know Him.
          </p>
        </div>
      </div>
    </section>
  );
};

export default AboutSHAY;
